module.exports = __webpack_public_path__ + "static/media/flowers_1.d712cdd3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_1.csv
// module id = 748
// module chunks = 0